<template>
  <div class="content mt-56">
    <div class="filter-row">
      <div class="filter-row-content">
        <div
          class="filter-item-wrap"
          v-for="(item, index) in typeList"
          :key="index"
        >
          <div
            class="item-bottom-10 filter-item"
            @click="typeSelect(item, index)"
            :class="{ 'select-item': activeType == item.value }"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="nodata-container" v-if="!couponList.length">
      <img src="@/static/coupon_empty.png" alt />
      <div class="s6 t3">暂无此类型优惠券</div>
    </div>
    <ul class="payment-mode-list" v-else>
      <li v-for="(item, index) in couponList" :key="index" class="payment-mode">
        <div class="t1 flex">
          <div class="left-count text-center">
            <div class="s4 c1">
              ￥<span class="s10 font-bold">{{ item.valueAmount }}</span>
            </div>
            <div class="t1 s4 min-limit">
              {{
                item.minLimitAmount
                  ? `满${item.minLimitAmount}可用`
                  : '无门槛优惠券'
              }}
            </div>
          </div>
          <div class="right-count">
            <div class="t1 s8  name">{{ item.name }}</div>
            <div class="t3 s4">
              {{ dayjs(item.validFrom).format('YYYY.MM.DD') }} ~
              {{ dayjs(item.validEnd).format('YYYY.MM.DD') }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs } from '@vue/composition-api'
import { getCouponApi } from '@/api/pay'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { openurl } from '@em/ym'
dayjs.extend(isBetween)

export default {
  setup() {
    const couponList = ref({})
    const state = reactive({
      viewState: '',
      activeType: null,
      typeList: [
        { name: '全部', value: null },
        { name: '全场券', value: 1 },
        { name: '品类券', value: 2 },
        { name: '单品券', value: 3 }
      ]
    })

    onMounted(() => {
      getCouponData()
    })

    async function getCouponData() {
      const type = state.typeList.find(a => a.value === state.activeType).value
      const { detail, result } = await getCouponApi(
        {
          type: type,
          direction: state.viewState ? 2 : 0,
          statusList: [0]
        },
        state.viewState
      )
      if (result.code === 0) {
        couponList.value = detail.list
      }
    }

    function typeSelect(item) {
      state.activeType = item.value
      state.viewState = ''
      getCouponData()
    }

    function btnClick(item) {
      if (!item.btnActive) return
      if (item.appLinkUrl) openurl(item.appLinkUrl)
    }
    return {
      ...toRefs(state),
      couponList,
      typeSelect,
      btnClick,
      dayjs
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  height: 100vh;

  .title {
    padding-bottom: 20px;
  }
}
.flex {
  display: flex;
}
.min-limit {
  margin-top: 18px;
  padding-left: 10px;
}
.text-center {
  text-align: center;
}

.payment-mode-list {
  list-style: none;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .payment-mode {
    position: relative;
    height: 156px;
    display: flex;
    align-items: center;
    margin-bottom: 21px;
    background: url('./images/bg1.png') no-repeat center;
    background-size: cover;

    .icon {
      width: 44px;
      height: 100%;
      margin-right: 20px;
      background: no-repeat center;
      background-size: contain;
    }

    .click-btn {
      position: absolute;
      right: 24px;
      top: calc(50% - 22px);
      bottom: 0;
      width: 120px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #858585;
      border-radius: 8px;
      &.is-active {
        border: 1px solid #e64c2e;
      }
    }

    .left-count {
      flex: 0 0 180px;
    }
    .right-count {
      flex: 0 0 100%;
      padding-left: 54px;
    }
    .name {
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: bold;
      margin-bottom: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 400px;
    }
  }
}
.filter-row {
  align-items: flex-start;
  display: flex;
  margin-bottom: 6px;
  margin-top: 40px;
}

.filter-row-content {
  display: flex;
  align-items: center;
  align-content: space-between;
  flex-flow: row wrap;
  justify-content: space-between;
  flex: 1;
  div {
    font-size: 24px;
    color: #858585;
  }
  .select-item {
    border: 1px solid #0079ff;
    color: #0079ff;
    background: #ffffff;
  }
}
.filter-item-wrap {
  width: 22%;
  margin-right: 3%;
  &:nth-child(4n) {
    margin-right: 0;
  }
}
.filter-item {
  height: 50px;
  color: #858585;
  background-color: rgba(85, 85, 85, 0.1);
  border-radius: 5px;
  text-align: center;
  line-height: 50px;
  letter-spacing: 1px;
  cursor: pointer;
  flex: none;
  box-sizing: border-box;
}

.item-bottom-10 {
  margin-bottom: 24px;
}

.nodata-container {
  width: 100%;
  height: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nodata-container img {
  width: 402px;
  height: 194px;
  margin-bottom: 26px;
}
</style>
